import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Label } from './ui/label';
import { Button } from './ui/button';

interface BatchVoteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  companies: string[];
  batchType: 'good' | 'bad';
  onBatchTypeChange: (type: 'good' | 'bad') => void;
  onConfirm: () => void;
}

export const BatchVoteDialog: React.FC<BatchVoteDialogProps> = ({
  isOpen,
  onClose,
  companies,
  batchType,
  onBatchTypeChange,
  onConfirm
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-800 border-slate-700 text-white">
        <DialogHeader>
          <DialogTitle>Mark {companies.length} Companies</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="text-sm text-slate-300">
            You've pasted a list of {companies.length} companies. How would you like to mark them all?
          </div>
          <RadioGroup value={batchType} onValueChange={(value: 'good' | 'bad') => onBatchTypeChange(value)}>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="good" id="good" />
              <Label htmlFor="good" className="text-green-400">Mark all as Good Examples (Positive)</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="bad" id="bad" />
              <Label htmlFor="bad" className="text-red-400">Mark all as Bad Examples (Negative)</Label>
            </div>
          </RadioGroup>
          <div className="text-xs text-slate-400 max-h-32 overflow-y-auto bg-slate-700 p-2 rounded">
            <strong>Companies to add:</strong><br />
            {companies.slice(0, 10).join(', ')}
            {companies.length > 10 && ` ... and ${companies.length - 10} more`}
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onConfirm} className="bg-gradient-to-r from-indigo-600 to-purple-600">
            Add All Companies
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}; 